import type { IAugmentedJQuery, IController, IScope } from "angular";

export default class EnumFlagDirectiveCntroller implements IController {
    public static $inject = ["$scope", "$element"];

    public model: number;

    public flagValue: number;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery) {}

    /* eslint-disable no-bitwise */
    public $onInit() {
        const checkbox = this.$element[0] as HTMLInputElement;

        checkbox.checked = (this.model & this.flagValue) === this.flagValue;

        this.$element.on("change", () => {
            this.$scope.$apply(() => {
                if (checkbox.checked) {
                    this.model |= this.flagValue;
                } else {
                    this.model -= this.model & this.flagValue;
                }
            });
        });
        this.$scope.$watch("$ctrl.model", (newValue: number, oldValue: number) => {
            if ((newValue & this.flagValue) === (oldValue & this.flagValue)) {
                return;
            }

            const shouldBeChecked = (this.model & this.flagValue) === this.flagValue;
            if (checkbox.checked !== shouldBeChecked) {
                checkbox.checked = shouldBeChecked;
            }
        });
    }
    /* eslint:enable */
}
